export enum ContentSubtype {
    Movie = 1,
    TvSingle = 2,
    FeatureDocumentary = 3,
    ShortFilm = 4,
    TV = 5,
    Advert = 6,
    Promo = 7,
    Safety = 8,
    IndentWarning = 9,
    ClientSpecific = 10
}
